import { OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import React, { useContext, useEffect, useState } from "react";
import styles from "./Analytics.module.scss";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../../stores/RootStore";
import BeatLoader from "react-spinners/BeatLoader";
import moment from "moment";
import YandexLogo from "assets/icons/yandex.png";
import OzonLogo from "assets/icons/ozon.png";
import WildberriesLogo from "assets/icons/wildberries.png";
import { useSearchParams } from "react-router-dom";

const SellerAnalytics: React.FC = observer(() => {
  const {
    orderStore: { getSellersOrdersAnalytics, sellersAnalytics },
    userStore: { userInfo },
  } = useContext(RootStoreContext);

  const [loading, setLoading] = useState<boolean>(true);

  const [startDate, setStartDate] = useState<string>(
    moment().subtract(7, "days").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState<string>(moment().format("YYYY-MM-DD"));

  const [searchParams] = useSearchParams();

  const tab = searchParams.get("tab");
  useEffect(() => {
    setLoading(true);
    if (userInfo && tab === "sellersOrdersAnalytics") {
      getSellersOrdersAnalytics(
        startDate,
        endDate,
        userInfo.mpWarehouseID
      ).then(() => {
        setLoading(false);
      });
    }
  }, [getSellersOrdersAnalytics, startDate, endDate, userInfo, tab]);

  return (
    <>
      <div className={styles.dates}>
        <div>
          <div>Период</div>

          <div>
            от:
            {
              <input
                type="date"
                value={startDate}
                onChange={(e) => {
                  setStartDate(e.target.value);
                }}
              />
            }
          </div>

          <div>
            до:
            {
              <input
                type="date"
                value={endDate}
                onChange={(e) => {
                  setEndDate(e.target.value);
                }}
              />
            }
          </div>
        </div>
        {sellersAnalytics ? (
          <div>
            <div>Всего: {sellersAnalytics.allSellers}</div>
            <div>Активные(есть продажи): {sellersAnalytics.activeSellers}</div>
          </div>
        ) : (
          ""
        )}
      </div>
      {loading ? (
        <div style={{ width: "fit-content", margin: "auto" }}>
          <BeatLoader color={"#f49100"} loading={loading} size={50} />
        </div>
      ) : (
        <Table striped hover>
          <thead>
            <tr>
              <th>Поставщик</th>
              <th>Продажи</th>
              <th>Возврат</th>
              <th>Итого</th>
              <th>% комиссии</th>
              <th>Сумма комиссии</th>
            </tr>
          </thead>
          <tbody>
            {sellersAnalytics &&
              sellersAnalytics.ordersAnalytics.map((item, index) => (
                <>
                  <tr key={index}>
                    <td>{item.name}</td>
                    <td>{item.allSales}</td>
                    <td>{item.allReturns}</td>
                    <td>{item.allReturns + item.allSales}</td>
                    <td>{item.comissionPercent}</td>
                    <td>{item.comissionAmount}</td>
                  </tr>
                  <tr key={index}>
                    <td className={styles.MPLogos}>
                      <img src={WildberriesLogo} alt="wildberries logo" />
                    </td>
                    <td>{item.wildberriesSales}</td>
                    <td>{item.wildberriesReturns}</td>
                    <td>{item.wildberriesSales + item.wildberriesReturns}</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr key={index}>
                    <td className={styles.MPLogos}>
                      <img src={OzonLogo} alt="ozon logo" />
                    </td>
                    <td>{item.ozonSales}</td>
                    <td>{item.ozonReturns}</td>
                    <td>{item.ozonSales + item.ozonReturns}</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr key={index}>
                    <td className={styles.MPLogos}>
                      <img src={YandexLogo} alt="yandex logo" />
                    </td>
                    <td>{item.yandexSales}</td>
                    <td>{item.yandexReturns}</td>
                    <td>{item.yandexSales + item.yandexReturns}</td>
                    <td></td>
                    <td></td>
                  </tr>
                </>
              ))}
          </tbody>
        </Table>
      )}
    </>
  );
});
export default SellerAnalytics;
